import React, { useState } from 'react'
import { useSelector } from 'react-redux'


import { Link } from 'react-router-dom';
function StudentTraniscation() {

    const {user} = useSelector((state)=>state.profile)
   const studentId = user._id


  return (
    <div className='w-full h- flex justify-center items-center'>
       
    <Link 
    className="bg-yellow-50 p-3 rounded-3xl font-mulish lg:text-xl hover:bg-yellow-5 transition-all font-bold "
    to={`/dashboard/student/${studentId}`}>
        Click And Know Your book transication
    </Link>
    </div>
  )
}

export default StudentTraniscation